import { RootQuery } from './root.query';
import { RootService } from './root.service';
import { RootStore } from './root.store';

export * from './root.query';
export * from './root.service';
export * from './root.store';

export default [RootStore, RootQuery, RootService];
